module.exports = __webpack_public_path__ + "img/pen.685a1e29.svg";